// Guia dos Sabores na MTC (pág. 37 / física 39) e Alimentos por Elemento (pág. 38 / física 40). Fiel ao PDF.

export const FLAVORS = [
  {
    id: "azedo",
    sabor: "Azedo",
    elemento: "madeira",
    orgaos: "Fígado e Vesícula Biliar",
    equilibrio: "Ajuda a recolher, organizar e dar direção.",
    excesso: "Em excesso pode aumentar contração, irritação ou rigidez.",
    sourcePages: [37],
    source: { pdfPage: 39, printedPage: "37" },
  },
  {
    id: "amargo",
    sabor: "Amargo",
    elemento: "fogo",
    orgaos: "Coração, Intestino Delgado, Pericárdio e Triplo Aquecedor",
    equilibrio: "Ajuda a limpar excessos e trazer clareza.",
    excesso: "Em excesso pode ressecar ou esfriar demais.",
    sourcePages: [37],
    source: { pdfPage: 39, printedPage: "37" },
  },
  {
    id: "doce",
    sabor: "Doce Natural",
    elemento: "terra",
    orgaos: "Estômago e Baço-Pâncreas",
    equilibrio: "Nutre, estabiliza e apoia a energia.",
    excesso: "Em excesso pode gerar peso, lentidão e umidade.",
    sourcePages: [37],
    source: { pdfPage: 39, printedPage: "37" },
  },
  {
    id: "picante",
    sabor: "Picante",
    elemento: "metal",
    orgaos: "Pulmão e Intestino Grosso",
    equilibrio: "Movimenta, dispersa e favorece circulação.",
    excesso: "Em excesso pode aquecer, irritar ou ressecar.",
    sourcePages: [37],
    source: { pdfPage: 39, printedPage: "37" },
  },
  {
    id: "salgado",
    sabor: "Salgado",
    elemento: "agua",
    orgaos: "Rins e Bexiga",
    equilibrio: "Amolece, direciona para dentro e apoia reservas.",
    excesso: "Em excesso pode sobrecarregar líquidos e energia.",
    sourcePages: [37],
    source: { pdfPage: 39, printedPage: "37" },
  },
];

export const FLAVOR_NOTE =
  "Na Medicina Tradicional Chinesa, os sabores são observados como qualidades energéticas dos alimentos. Eles ajudam a entender relações, mas não substituem orientação profissional ou nutricional. Este guia é educativo.";

export const FLAVOR_HOW_TO = [
  "Observe o sabor predominante.",
  "Relacione com o elemento.",
  "Consulte o órgão correspondente.",
  "Evite excessos.",
  "Registre como você se sente.",
];

export const FLAVOR_SIDE_CARDS = {
  consciencia: {
    titulo: "Use com consciência",
    texto: "Prefira variedade, moderação e alimentos simples. Observe como seu corpo responde.",
  },
  naoPrescricao: {
    titulo: "Não é prescrição",
    texto: "Este guia é educativo. Ajustes alimentares devem considerar sua realidade e orientação profissional quando necessário.",
  },
  frase: "“Equilíbrio não está em evitar tudo, mas em aprender medida, contexto e presença.”",
};

export const FOODS = [
  {
    id: "madeira",
    elemento: "madeira",
    orgaos: "Fígado e Vesícula Biliar",
    sabor: "Azedo",
    exemplos: ["limão", "folhas verdes", "alcachofra", "rabanete", "maçã", "brotos"],
    nota: "Ajuda a lembrar movimento, direção e flexibilidade.",
    sourcePages: [38],
    source: { pdfPage: 40, printedPage: "38" },
  },
  {
    id: "fogo",
    elemento: "fogo",
    orgaos: "Coração, Intestino Delgado, Pericárdio e Triplo Aquecedor",
    sabor: "Amargo",
    exemplos: ["cacau amargo", "folhas amargas", "chá verde", "rúcula", "escarola"],
    nota: "Relaciona-se à clareza, presença e calor equilibrado.",
    sourcePages: [38],
    source: { pdfPage: 40, printedPage: "38" },
  },
  {
    id: "terra",
    elemento: "terra",
    orgaos: "Estômago e Baço-Pâncreas",
    sabor: "Doce Natural",
    exemplos: ["abóbora", "arroz integral", "batata-doce", "aveia", "cenoura cozida", "maçã cozida"],
    nota: "Nutre, estabiliza e apoia energia cotidiana.",
    sourcePages: [38],
    source: { pdfPage: 40, printedPage: "38" },
  },
  {
    id: "metal",
    elemento: "metal",
    orgaos: "Pulmão e Intestino Grosso",
    sabor: "Picante",
    exemplos: ["gengibre", "cebola", "alho", "nabo", "pera cozida", "hortelã"],
    nota: "Movimenta, dispersa e favorece leveza.",
    sourcePages: [38],
    source: { pdfPage: 40, printedPage: "38" },
  },
  {
    id: "agua",
    elemento: "agua",
    orgaos: "Rins e Bexiga",
    sabor: "Salgado",
    exemplos: ["feijão preto", "gergelim preto", "algas", "sopas mornas", "água", "nozes"],
    nota: "Apoia reserva, descanso e profundidade.",
    sourcePages: [38],
    source: { pdfPage: 40, printedPage: "38" },
  },
];

export const FOOD_NOTE =
  "Na Medicina Tradicional Chinesa, os alimentos também podem ser observados por sua relação com elementos, sabores e órgãos. Esta página é educativa e serve como referência de consulta. Nenhum elemento precisa dominar o prato — o equilíbrio nasce da combinação, da moderação e da resposta do corpo.";

export const FOOD_HOW_TO = [
  "Consulte o elemento.",
  "Observe o sabor.",
  "Escolha alimentos simples.",
  "Evite excessos.",
  "Anote como se sente.",
];

export const FOOD_SIDE_CARDS = {
  variedade: {
    titulo: "Variedade",
    texto: "Nenhum elemento precisa dominar o prato. O equilíbrio nasce da combinação.",
  },
  moderacao: {
    titulo: "Moderação",
    texto: "Mais importante do que exagerar em um alimento é observar quantidade, contexto e resposta do corpo.",
  },
  frase: "“Alimentar-se com consciência é transformar rotina em cuidado.”",
};
